import React from "react";

function Trip() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M16.25 0C15.5596 0 15 0.559644 15 1.25V7.5H11.25C9.17893 7.5 7.5 9.17893 7.5 11.25V33.75C7.5 35.386 8.54768 36.7774 10.0087 37.2897C10.003 37.359 10 37.4292 10 37.5C10 38.8807 11.1193 40 12.5 40C13.8807 40 15 38.8807 15 37.5H25C25 38.8807 26.1193 40 27.5 40C28.8807 40 30 38.8807 30 37.5C30 37.4292 29.9971 37.359 29.9913 37.2897C31.4523 36.7774 32.5 35.386 32.5 33.75V11.25C32.5 9.17893 30.8211 7.5 28.75 7.5H25V1.25C25 0.559644 24.4404 0 23.75 0H16.25ZM22.5 7.5H17.5V2.5H22.5V7.5ZM10 17.5V15H30V17.5H10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Trip;
